// Initialize Swiper
  const swiper = new Swiper('.quiz_swiper', {
    direction: 'horizontal',
    loop: false,
    autoHeight:true,
    allowTouchMove: false, // Disable drag/swipe
    pagination: {
      el: '.quiz_swiper-pagination',
      clickable: false,
    },
});


  // Quiz Flow Data
  const quizFlow = {
    "Medical Professionals": [
      {
        qid: 1,
        question: "Which group do you resonate with?",
        type: "radio",
        options: ["Physician", "Physical Therapist", "Chiropractor", "Nurse", "Practitioner"],
      },
      {
        qid: 2,
        question: "How familiar are you with far infrared technology?",
        type: "radio",
        options: ["Beginner", "Intermediate", "Advanced"],
      },
      {
        qid: 3,
        question: "Do you incorporate far infrared therapy in your medical protocols?",
        type: "radio",
        options: ["Always", "Yes", "Periodically", "Not Yet"],
      },
    ],
    "Wellness Professionals": [
      {
        qid: 1,
        question: "Which group do you resonate with?",
        type: "radio",
        options: ["Naturopath", "Acupuncturist", "Massage Therapist", "Wellness Coach", "Spiritual Advisor", "Energy Worker"],
      },
      {
        qid: 2,
        question: "What’s your experience with far infrared technology?",
        type: "radio",
        options: ["Beginner", "Intermediate", "Advanced"],
      },
      {
        qid: 3,
        question: "Do you incorporate far infrared therapy in your wellness programs?",
        type: "radio",
        options: ["Always", "Yes", "Periodically", "Not Yet"],
      },
    ],
    "Sports & Fitness Aficionado": [
      {
        qid: 1,
        question: "Which group do you resonate with?",
        type: "radio",
        options: ["Athletes", "Personal Trainers", "Fitness Aficionado", "Coach", "Instructor"],
      },
      {
        qid: 2,
        question: "Do you currently use a sauna?",
        type: "radio",
        options: ["Yes", "No"],
      },
      {
        qid: 3,
        question: "What’s your experience with far infrared technology?",
        type: "radio",
        options: ["Beginner", "Intermediate", "Advanced"],
      },
      {
        qid: 4,
        question: "What are you currently seeking to achieve?",
        type: "radio",
        options: ["Recovery", "Boost performance", "Weight loss", "Increased HRV", "Increased Muscle density", "Gain strength", "Improve flexibility", "Quicker warm-ups", "Increase Vo2 max", "Mental clarity", "Decrease inflammation", "Decreased inflammation", "Improved sleep quality"],
      },
    ],
    "Beauty & Personal Care Aficionado": [
      {
        qid: 1,
        question: "Which group do you resonate with?",
        type: "radio",
        options: ["Self-care Specialist", "Aesthetician", "Cosmetologist", "Personal Care Aficionado"],
      },
      {
        qid: 2,
        question: "Do you currently use a sauna?",
        type: "radio",
        options: ["Newbie", "Casual", "Enthusiast"],
      },
      {
        qid: 3,
        question: "What’s your experience with far infrared technology?",
        type: "radio",
        options: ["Beginner", "Intermediate", "Advanced"],
      },
      {
        qid: 4,
        question: "What are you currently seeking to achieve?<br/>(Select multiple)",
        type: "checkbox",
        options: ["Collagen building", "Weight Loss", "Lean muscle mass", "Oxygenated Skin", "Mental clarity", "Hair regeneration", "Detox", "Skin revitalization", "Relaxation", "Enhanced beauty rituals", "Elevated skincare", "Hormonal balance", "Spiritual well being", "Decreased inflammation", "Improved sleep quality"],
      },
    ],
    "Optimal Health Consumers": [
      {
        qid: 1,
        question: "Which group do you resonate with?",
        type: "radio",
        options: ["Biohackers", "Eco-Conscious", "Optimal Health Enthusiast"],
      },
      {
        qid: 2,
        question: "Do you currently use a sauna?",
        type: "radio",
        options: ["Newbie", "Casual", "Enthusiast"],
      },
      {
        qid: 3,
        question: "What’s your experience with far infrared technology?",
        type: "radio",
        options: ["Newbie", "Casual", "Enthusiast"],
      },
      {
        qid: 4,
        question: "What are you currently seeking to achieve?",
        type: "radio",
        options: ["Cognitive clarity", "Age proofing", "Mitochondria repair", "Nitric Oxide boosting", "Parasympathetic nervous system reboot", " Increased HRV", "Increase Vo2 max", "Hormonal balance", "Increase ATP", "Increase microcirculation", "Decreased inflammation", "Improved sleep quality", "Enhance your health metrics"],
      },
    ],
  };

  // Handle Continue Button
  document.querySelector('.continue-btn').addEventListener('click', () => {
    const selectedOption = document.querySelector('input[type="radio"]:checked');
    const startq = document.querySelector('input[name="pathway"]:checked');
    if (selectedOption) {
      const pathway = selectedOption.value;
      const _startq = startq.value;
      console.log(pathway);
      if (quizFlow[pathway]) {
        generateSlides(quizFlow[pathway], _startq);
        swiper.slideNext(); // Move to the first generated slide
      } else {
        alert("Pathway not defined!");
      }
    } else {
      alert("Please select an option!");
    }
  });

function generateSlides(questions, startq) {
  const swiperWrapper = document.querySelector('.swiper-wrapper');

  // Clear existing dynamically generated slides
  Array.from(swiperWrapper.children).forEach((child, index) => {
    if (index > 0) child.remove(); // Keep the first slide
  });

  // Create slides for each question
  questions.forEach((item) => {
    const slide = document.createElement('div');
    slide.classList.add('quiz_slide', 'swiper-slide');
    slide.innerHTML = `
      <div class="quiz_slide_wrapper">
        <div class="quiz_text">
          <div class="quiz_text_wrapper">
            <h2 class="h2 title">${item.question}</h2>
          </div>
        </div>
        <div class="quiz_form">
          <div class="quiz_form_wrapper">
            ${item.options
              .map(
                (option, index) => `
              <div class="quiz_field">
                <input type="${item.type}" name="question-${item.qid}" id="option-${item.qid}-${index}" value="${option}">
                <label for="option-${item.qid}-${index}">${option}</label>
              </div>
            `
              )
              .join("")}
            <button class="continue-btn button button--primary focus-inset quiz_btn">Continue</button>
          </div>
        </div>
      </div>
    `;
    swiperWrapper.appendChild(slide);
  });

  // Add the final slide for Name and Email
  const finalSlide = document.createElement('div');
  finalSlide.classList.add('quiz_slide', 'swiper-slide');
  finalSlide.innerHTML = `
    <div class="quiz_slide_wrapper">
      <div class="quiz_text">
        <div class="quiz_text_wrapper">
          <h2 class="h2 title">You're one step away away to a healthy upgrade!</h2>
        </div>
      </div>
      <div class="quiz_form">
        <div class="quiz_form_wrapper">
          
          <input type="hidden" name="pathway" value="`+startq+`"/>
          <div class="quiz_field quiz_text_field">
            <label for="customer-name">Name</label>
            <input type="text" class="quiz-input-fiels" id="customer-name" name="customer-name" placeholder="Enter your name" required>
          </div>
          <div class="quiz_field quiz_text_field">
            <label for="customer-email">Email</label>
            <input type="email" class="quiz-input-fiels" id="customer-email" name="customer-email" placeholder="Enter your email" required>
          </div>
          <button class="submit-btn button button--primary focus-inset quiz_btn">Submit</button>

        </div>
      </div>
    </div>
  `;
  swiperWrapper.appendChild(finalSlide);

  // Reinitialize Swiper
  swiper.update();
  attachEventListeners();
}



  // Attach Event Listeners to Continue Buttons
	function attachEventListeners() {
	  document.querySelectorAll('.continue-btn').forEach((button) => {
        button.addEventListener('click', () => {
          const currentSlide = button.closest('.swiper-slide'); // Find the closest slide to the clicked button
      
          // Determine if the slide has radio or checkbox inputs
          const radioInput = currentSlide.querySelector('input[type="radio"]');
          const checkboxInput = currentSlide.querySelector('input[type="checkbox"]');
      
          let isValid = false; // To track if any option is selected
          let questionName = "";
      
          if (radioInput) {
            // Handle radio buttons
            questionName = radioInput.name; // Dynamically get the name
            const selectedOption = currentSlide.querySelector(`input[name="${questionName}"]:checked`);
            isValid = !!selectedOption; // Check if any radio button is selected
          } else if (checkboxInput) {
            // Handle checkboxes
            questionName = checkboxInput.name; // Dynamically get the name
            const selectedOptions = currentSlide.querySelectorAll(`input[name="${questionName}"]:checked`);
            isValid = selectedOptions.length > 0; // Check if at least one checkbox is selected
          }
      
          if (isValid) {
            swiper.slideNext(); // Move to the next slide
          } else {
            alert("Please select at least one option!");
          }
        });
      });


	  // Handle Submit button click
	  document.querySelector('.submit-btn').addEventListener('click', () => {
        const startq = document.querySelector('input[name="pathway"]:checked');

        if (startq) {
            let _startq = startq.value;
        
            switch (_startq) {
                case "Medical Professionals":
                    _startq = "medical";
                    _url = "/pages/result-medical";
                    break;
                case "Sports & Fitness Aficionado":
                    _startq = "sports";
                    _url = "/pages/result-sports";
                    break;
                // Add other cases as needed
                case "Wellness Professionals":
                    _startq = "wellness";
                    _url = "/pages/result-wellness";
                    break;
                case "Beauty & Personal Care Aficionado":
                    _startq = "beauty";
                    _url = "/pages/result-beauty";
                    break;
                case "Optimal Health Consumers":
                    _startq = "optimal";
                    _url = "/pages/result-optimal";
                    break;
            }
        
        }
        
	    // Collect all selected answers
        const answers = {};
        
        // Collect selected radio button values
        document.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
          answers[input.name] = input.value;
        });
        
        // Collect selected checkbox values
        document.querySelectorAll('input[type="checkbox"]:checked').forEach((input) => {
          // If the question has multiple selected values (checkbox), store them as an array
          if (!answers[input.name]) {
            answers[input.name] = [];
          }
          answers[input.name].push(input.value);
        });
        
        // Collect Name and Email
        const name = document.getElementById('customer-name').value.trim();
        const email = document.getElementById('customer-email').value.trim();
        
        if (!name || !email) {
          alert("Please fill out both Name and Email fields!");
          return;
        }
        
        // Add Name and Email to the answers
        answers.firstName = name; // Updated to match the PHP structure
        answers.email = email;
        
        // Define the third-party server endpoint
        const thirdPartyUrl = 'https://vshey.co/process.php';
        
        // Send data to the server
        fetch(thirdPartyUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(answers),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
          })
          .then((data) => {
            if (data.success) {
              // If the response indicates success, redirect the user
              const queryParams = new URLSearchParams(answers).toString();
              window.location.href = `${_url}?access=1`;
            } else {
              // Handle errors (e.g., display a message to the user)
              alert(data.message || 'An error occurred while submitting your data. Please try again.');
              console.error('Error:', data.debug || data);
            }
          })
          .catch((error) => {
            // Handle network or unexpected issues
            alert('Failed to send data. Please try again.');
            console.error('Network Error:', error);
          });

	  });
	}